module.exports = __webpack_public_path__ + "static/media/broxel-horizontal-eng.71c0e67c.png";